<template>
  <div id="app">
    <router-view />
    <div class="sus" v-if="$route.path !== '/classhub_download'">
      <div class="divwechat" style="margin-top: 14px;">
        <div class="thepublic thepublic1">
          <div class="help">需要帮助？</div>
          <div class="server">极域产品顾问为您服务</div>
          <img src="./assets/images/home/sus/ewm.jpg" alt="" class="ewmwh" />
          <div class="focus">扫码关注：<span>极域公众号</span></div>
        </div>
      </div>
      <div class="divphone">
        <div class="number">
          <div class="son num1"><span class="lable">VIP技术热线：</span><span>400-870-9018</span></div>
          <div class="son"><span class="lable">VIP销售热线：</span><span>170 025 56777</span></div>
          <div class="son num2"><span class="lable" style="visibility: hidden;">VIP销售热线：</span><span>170 025 56999</span></div>
        </div>
      </div>
      <div>
        <img
          src="./assets/images/home/sus/top.png"
          alt=""
          id="top"
          class="top"
          @click="toTop"
        />
      </div>

    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'App',
  data () {
    return {

    }
  },
  watch: {
    $route: {
      handler (val, oldval) {
        $('#sysBody').removeClass('sysBody')
        if (val.name !== oldval.name) {
          window.scrollTo(0, 0)
        }
      },
      deep: true
    }
  },
  mounted () {
    if (window.innerWidth > 768) {
      setTimeout(() => {
        document.getElementById('icon_module').style.right = '0'
        document.getElementById('icon_module').style.left = 'initial'
        document.getElementById('icon_module').style.top = 'initial'
        document.getElementById('icon_module').style.bottom = '380px'
        document.getElementById('icon_module').style.display = 'none'
      }, 500)
    }
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    toTop () {
      $('html,body').animate({ scrollTop: 0 }, 500)
    },
    handleScroll () {
      let tmp = window.innerWidth
      if (document.body.scrollTop > document.body.offsetHeight || document.documentElement.scrollTop > document.body.offsetHeight) {
        if (tmp > 1440) {
          document.getElementById('top').style.width = '60px'
        } else {
          document.getElementById('top').style.width = '48px'
        }
      } else {
        document.getElementById('top').style.width = '0'
      }
    }
  }
}
</script>

<style lang="less">
.hidden-chat {
  height: 0!important;
}
.required::before {
  content: "*";
  display: inline-block;
  margin-right: 4px;
  line-height: 1;
  font-family: SimSun;
  font-size: 14px;
  color: #ed4014;
  position: absolute;
  left: -14px;
  line-height: 38px;
}
/deep/ .ivu-btn {
  height: 38px;
}
/deep/ .ivu-input {
  line-height: 24px;
  height: 40px
}
.ivu-select-item {
  line-height: 30px;
}
#app {
  font-family: "AlibabaPuHuiTi","Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
html,
body {
  font-family: "AlibabaPuHuiTi","Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB",Arial,sans-serif;
  height: 100%;
  width: 100%;
}
.show {
  display: block;
}
.notshow {
  display: none;
}
body {
  margin: 0;
  padding: 0;
}
a {
  list-style: none !important;
  text-decoration: none !important;
}
.col-lg-1,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-md-1,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-sm-1,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-xs-1,
.col-xs-10,
.col-xs-11,
.col-xs-12,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.ivu-notice {
  top: 100px !important;
}
.sus {
  height: auto;
  display: flex;
  flex-direction: column;
  position: fixed;
  right: 20px;
  bottom: 430px;
  z-index: 1000;

  .divwechat {
    width: 60px;
    height: 60px;
    position: relative;
    background: url(./assets/images/home/sus/wechat.png) no-repeat top center;
    background-size: cover;

    .thepublic {
      width: 0;
      height: 260px;
      background: #fff;
      position: absolute;
      right: 120%;
      bottom: -7%;
      border-radius: 10px;
      transition: width 0.8s ease;
      overflow: hidden;

      .help {
        width: 220px;
        font-size: 16px;
        line-height: 28px;
        margin-top: 20px;
        text-align: center;
        color: #000;
        overflow: hidden;
        white-space: nowrap;
      }
      .server {
        width: 220px;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        color: #aaa;
        white-space: nowrap;
      }
      .ewmwh {
        width: 150px;
        height: 150px;
        margin-left: 35px;
        overflow: hidden;
      }
      .focus {
        width: 220px;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        white-space: nowrap;
        color: #aaa;
        span {
          color: blue;
        }
      }
    }

    &:hover {
      background: url(./assets/images/home/sus/wechatH.png) no-repeat top center;
      .thepublic {
        width: 220px;
        box-shadow: darkgrey 0px 0px 20px 0px;
      }
    }
  }
  .divphone1 {
    display: none;
  }
  .divphone {
    width: 60px;
    height: 60px;
    margin-top: 14px;
    margin-bottom: 14px;
    position: relative;
    background: url(./assets/images/home/sus/phoneH.png) no-repeat top center;
    background-size: cover;

    .number {
      width: 240px;
      height: 80px;
      background: #fff;
      position: absolute;
      right: 120%;
      bottom: -32%;
      border-radius: 10px;
      transition: width 0.8s ease;
      overflow: hidden;
      font-weight: 600;
      line-height: 22px;
      box-shadow: darkgrey 0px 0px 20px 0px;

      .son {
        width: 100%;
        font-size: 16px;
        color: blue;
        text-align: left;
        padding-left: 12px;
      }
      .lable {
        display: block;
        float: left;
        width: 110px;
      }
      .num1 {
        margin-top: 8px;
      }
    }

    &:hover {
      background: url(./assets/images/home/sus/phoneH.png) no-repeat top center;
      background-size: cover;
      .number {
        width: 240px;
        box-shadow: darkgrey 0px 0px 20px 0px;
      }
    }
  }
  .top {
    width: 0;
    height: 60px;
    transition: width 0.8s;
    overflow: hidden;

    &:hover {
      content: url("./assets/images/home/sus/topH.png");
    }
  }
}
.title-icon {
  font-size: 24px;
  position: absolute;
  top: 10px;
  left: 10px;
  color: rgb(241, 241, 241);
}
.title-tip {
  color: #ffffff;
  line-height: 42px;
  margin-left: 48px;
  font-size: 14px;
}
.section-form-title {
  cursor: pointer;
  background: #3288e8;
  box-shadow: 0px 0px 6px #3288e8;
  width: 260px;
  position: fixed;
  right: 0px;
  bottom: 0px;
  height: 40px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  z-index: 1000;

  .close-btn {
    position: absolute;
    right: 12px;
    top: 10px;
    font-size: 20px;
    cursor: pointer;
    color: #fff;
  }
}
.section-form {
  background: #fff;
  width: 380px;
  position: fixed;
  right: 0px;
  bottom: 0px;
  display: flex;
  z-index: 1000;
  box-shadow: 0px 0px 6px #b9b9b9;
  border-radius: 6px;
  transition: height 0.3s ease-in-out;
  .close-btn {
    position: absolute;
    right: 12px;
    top: 12px;
    font-size: 20px;
    cursor: pointer;
    color: #fff;
  }

  .container {
    width: 100%;
    padding: 0;
    .section-form_top {
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      height: 44px;
      line-height: 44px;
      background: #3288e8;
      color: #ffffff;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
    }
    .section-form_bottom {
      margin: 36px 24px 10px;
      position: relative;
      /deep/ .ivu-form-item-content {
        margin-left: 0 !important;
      }
      .Yzcode {
        position: absolute;
        left: 0;
        top: 1px;
        width: 100px;
        height: 100%;
        padding: 1px 0;
        cursor: pointer;
      }
      .footer {
        margin-top: 10%;
        text-align: center;
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .sus {
    right: 10px;

    .divwechat {
      width: 48px;
      height: 48px;
      border-radius: 8px;
      background: url(./assets/images/home/sus/wechat.png) no-repeat top center;
      background-size: 100% 100%;

      .thepublic {
        width: 0;
        height: 185px;
        right: 120%;
        bottom: -8%;
        border-radius: 8px;

        .help {
          width: 150px;
          font-size: 14px;
          line-height: 24px;
          margin-top: 10px;
        }
        .server {
          width: 150px;
          font-size: 12px;
          line-height: 20px;
        }
        .ewmwh {
          width: 100px;
          height: 100px;
          margin-top: 0;
          margin-left: 25px;
        }
        .focus {
          width: 150px;
          font-size: 12px;
          line-height: 20px;
        }
      }
      &:hover {
        background: url(./assets/images/home/sus/wechatH.png) no-repeat top
          center;
        background-size: cover;
        .thepublic {
          width: 150px;
          box-shadow: darkgrey 0px 0px 20px 0px;
        }
      }
    }
    .divphone {
      width: 48px;
      height: 48px;
      position: relative;
      background: url(./assets/images/home/sus/phoneH.png) no-repeat top center;
      background-size: cover;

      .number {
        width: 184px;
        height: 74px;
        right: 120%;
        bottom: -55%;
        border-radius: 8px;
        line-height: 21px;

        .son {
          width: 184px;
          font-size: 12px;
          color: blue;
          text-align: left;
          padding-left: 10px;
        }
        .lable {
          display: block;
          float: left;
          width: 84px;
        }
      }
      &:hover {
        background: url(./assets/images/home/sus/phoneH.png) no-repeat top
          center;
        background-size: cover;
        .number {
          width: 184px;
          box-shadow: darkgrey 0px 0px 20px 0px;
        }
      }
    }

    .top {
      width: 48px;
      height: 48px;
    }
  }
}
@media screen and (max-width: 768px) {
  .sus {
    right: 10px;
    bottom: 4.4rem;
    .divwechat {
      display: none;
    }
    .divphone {
      width: 48px;
      height: 48px;
    }
    .top {
      display: none;
    }
  }
  .title-icon {
    top: 30%;
  }
  .title-tip {
    line-height: 1.24444rem;
  }
  .section-form-title {
    width: 100%;
    height: 1.24444rem;
    line-height: 1.24444rem;
    .close-btn {
      top: 30%;
    }
  }
  .section-form {
    width: ~"calc(100% - 20px)";
    right: 10px;
  }

}
</style>



// WEBPACK FOOTER //
// src/App.vue